import intersectionWith from 'lodash/intersectionWith';

export default valueGetter => (group1, group2) => {
  return (
    group1.id === group2.id &&
    group1.items.length === group2.items.length &&
    intersectionWith(
      group1.items,
      group2.items,
      (item1, item2) => valueGetter(item1) === valueGetter(item2)
    ).length === group1.items.length
  );
};
